import { tv } from "../../variants/tv.js";
const CarouselBlurBoxIncludedOptions = [
    'numbers',
    'lightbox',
    'autoplay'
];
const carouselBlurBoxVariants = tv({
    slots: {
        blurBoxSlot: 'bg-neutral-12/40 pointer-events-auto absolute bottom-2 right-2 flex items-center rounded-md backdrop-blur',
        blurBoxNumbersSlot: 'pointer-events-none flex min-h-7 items-center justify-center rounded-md',
        blurBoxLightboxButtonSlot: 'flex h-8 w-8 items-center justify-center rounded-md',
        blurBoxAutoplayButtonSlot: 'flex h-8 w-8 items-center justify-center rounded-md',
        blurBoxDividerSlot: 'bg-neutral-1/20 h-4 w-px'
    },
    variants: {
        numbers: {
            true: {
                blurBoxNumbersSlot: 'pointer-events-none flex min-h-7 items-center justify-center rounded-md px-2'
            },
            false: {}
        },
        numbersAndLightbox: {
            true: {
                blurBoxNumbersSlot: 'pointer-events-none flex min-h-7 items-center justify-center rounded-md pl-2'
            }
        },
        numbersAndAutoplay: {
            true: {
                blurBoxNumbersSlot: 'pointer-events-none flex min-h-7 items-center justify-center rounded-md px-2'
            }
        },
        numbersAndLightboxAndAutoplay: {
            true: {
                blurBoxNumbersSlot: 'pointer-events-none flex min-h-7 items-center justify-center rounded-md pl-2'
            }
        }
    },
    defaultVariants: {
        numbers: false
    }
});
export { CarouselBlurBoxIncludedOptions, carouselBlurBoxVariants };
